import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  // load translation using http -> see /public/locales
  .use(HttpApi)
  // detect user language
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  .init({
    fallbackLng: 'hr',
    debug: true, // Set to false in production
    supportedLngs: ['en', 'hr'],

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },

    backend: {
      // for all supported languages
      loadPath: '/locales/{{lng}}/translation.json',
    },
  });

export default i18n;
